<template>
	<div class="admin-page">
		<transition name="fade">
			<div v-if="loading" id="preloader-admin">
				<div id="status-admin"></div>
			</div>
		</transition>
		<admin-header :name="fullName" @logout="logout" :isAdminHome="isAdminHome"/>
		<admin-nav/>
		<slot/>
		<admin-footer/>
	</div>
</template>

<style lang="less">
	.label-red:hover {
		background-color: #a40d36;
		color: white;
	}
	.label-red:active {
		background-color: #a40d36;
		color: white;
	}
	.label-red:focus {
		background-color: #a40d36;
		color: white;
	}
	.fade-enter-active, .fade-leave-active {
		transition: opacity .65s;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
</style>

<script>
import adminNav from '@/components/admin-nav';
import adminHeader from '@/components/layout/admin/header.vue';
import adminFooter from '@/components/layout/admin/footer.vue';
import { mapGetters } from 'vuex';

export default {
	components: { adminHeader, adminFooter, adminNav },
	created() {
		this.runLoader();
	},
	data() {
		return {
			loading: false,
			isAdminHome: window.location.pathname === '/admin',
		};
	},
	computed: {
		...mapGetters({ user: 'user' }),
		fullName() {
			return `${this.user.first_name} ${this.user.last_name}`;
		},
	},
	methods: {
		async logout() {
			try {
				await this.$store.dispatch('logout');
			} catch (e) {
				throw new Error(e);
			}
		},
		runLoader() {
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
			}, 700);
		},
	},
};
</script>
